import { Box, Typography } from "@mui/material";
import useTotals from "../hooks/use-totals";
import { useWholesale } from "../store/wholesale";
import styled from "@emotion/styled";
import l10n from "../lib/l10n";

const PriceDel = styled(Typography)(({ theme }) => ({
  position: "absolute",
  top: "100%",
  lineHeight: 1,
  fontSize: "0.85em",
  my: 0,
  textDecoration: 'line-through',
  // background: theme.palette.background.paper,
  padding: '0 8px',
  left: '-8px',
}));

function Price(props) {
  const { priceContainer = {} } = props;
  const { getPublicPrice, getWholesalePrice } = useTotals();
  const wholesaleActive = useWholesale((state) => state.active);

  if (["yes","frontend"].includes(l10n.wppr_wallpaper_hide_price)
  || !l10n?.u_role) {
    return;
  }

  return (
    <>
      {props?.children}
      <Box style={{ position: "relative" }} {...priceContainer}>
        {wholesaleActive && <PriceDel>{getPublicPrice()}</PriceDel>}
        <Box sx={{
          fontSize: 'inherit',
          position: 'relative'
          // lineHeight: wholesaleActive ? 1 : 'initial',
          // mb: wholesaleActive ? '0.25em' : 0
        }}>
          <Box sx={{
            visibility: wholesaleActive ? 'visible' : 'hidden', 
            position: 'absolute', 
            height: '100%',
            // background: theme => theme.palette.background.paper,
            zIndex: 1
          }}>
            {getWholesalePrice()}
          </Box>
          <Box style={{ visibility: wholesaleActive ? 'hidden' : 'visible' }}>
            {getPublicPrice()}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Price;